module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDialog),
      expression: "showDialog"
    }],
    attrs: {
      "title": "Reset Password",
      "customClass": "customWidth",
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "visible": "false",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "account-box"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('p', {
    staticClass: "instructionalText"
  }, [_vm._v("\n             Instructions on how to reset your password was sent to the following email: "), _c('br'), _c('strong', [_vm._v(_vm._s(this.$route.params.email)), _c('br'), _c('br')]), _c('strong', [_vm._v(" If this email is associated with an account, you should receive an email shortly. ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row-block"
  }, [_c('div', {
    staticClass: "row"
  })])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1286221d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordReset.vue
// module id = 1268
// module chunks = 2